/** @jsxImportSource @emotion/react */

import { Box, css } from '@mui/material';
import { useEffect, useState } from 'react';
import samplebook from '../Types/samplebook';
import CloseIcon from '@mui/icons-material/Close';

const SamplebookList = (props: { sampleList: samplebook[] }) => {
  const { sampleList } = props;
  const [selectedSample, setSelectedSample] = useState<samplebook>({
    url: '',
    main: '',
    sub: '',
    id: '',
    design: '',
  });
  const [modalShow, setModalShow] = useState<boolean>(false);

  const handleClick = (s: samplebook) => {
    setSelectedSample(s);
  };

  useEffect(() => {
    if (!selectedSample || !selectedSample.url || selectedSample.url === '') {
      setModalShow(false);
    } else {
      setModalShow(true);
    }
  }, [selectedSample]);

  const handleModalClose = () => {
    setModalShow(false);
    setSelectedSample({
      url: '',
      main: '',
      sub: '',
      id: '',
      design: '',
    });
  };

  return (
    <Box css={style.root}>
      {sampleList.map((s) => {
        return (
          <Box onClick={handleClick.bind(this, s)} css={style.sampleBox} key={s.id}>
            <img css={[style.img, !!s.position && s.position === 't' ? style.topBox : {}]} src={s.url} alt={`${s.main}+${s.sub} image`} />
          </Box>
        );
      })}
      {!!modalShow && (
        <Box css={style.outer}>
          <Box css={style.modal}>
            <Box css={style.modalImgBox}>
              <img
                css={[style.modalImg, !!selectedSample.position && selectedSample.position === 't' ? style.modalTopBox : {}]}
                src={selectedSample.url}
                alt={`${selectedSample.main}+${selectedSample.sub} image`}
              />
            </Box>
            <Box onClick={handleModalClose} css={style.close}>
              <CloseIcon style={{ fontSize: 40 }} />
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

const style = {
  root: css`
    display: flex;
    width: 100%;
    flex-wrap: wrap;
  `,
  sampleBox: css`
    display: flex;
    width: 33.3%;
    box-sizing: border-box;
    background-size: contain;
    overflow: hidden;
    box-sizing: border-box;
    @media (max-width: 768px) {
      width: 50%;
    }
    @media (max-width: 320px) {
      width: 320px;
    }
    border: 1px solid white;
    &:hover {
      border: 1px dashed black;
    }
  `,
  img: css`
    width: 100%;
    height: 100%;
    -webkit-user-drag: none;
    cursor: pointer;
  `,
  topBox: css`
    transform: translate(0px, 8%);
  `,
  outer: css`
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100vh;
    background-color: #00000030;
    top: 0;
  `,
  modal: css`
    width: 80%;
    max-height: 90%;
    display: flex;
    background-color: white;
    position: relative;
    box-shadow: 1px 1px 8px black;
    border-radius: 8px;
    overflow: hidden;
    justify-content: center;
    @media (max-width: 425px) {
      width: 100%;
    }
  `,
  modalImgBox: css`
    display: flex;
    /* height: 100%;
    max-height: 1080px; */
    width: 100%;
  `,
  modalImg: css`
    width: 100%;
    object-fit: contain;
    -webkit-user-drag: none;
  `,
  modalTopBox: css`
    transform: translate(0px, 8%);
  `,
  close: css`
    position: absolute;
    top: 16px;
    right: 16px;
    justify-content: center;
    display: flex;
    font-size: 32px;
    border: 4px solid black;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    align-items: center;
    cursor: pointer;
    &:hover {
      color: tomato;
      border-color: tomato;
    }
  `,
};

export default SamplebookList;
